module.exports = __webpack_public_path__ + "static/media/rio.24b0e05c.jpeg";